import React from 'react'
import { Modal } from '@/components/ui/Modal'

interface DeleteViewModalProps {
  viewName: string
  onClose: () => void
  onConfirm: () => void
}

export const DeleteViewModal: React.FC<DeleteViewModalProps> = ({
  viewName,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal
      title="Supprimer la vue"
      isDanger={true}
      confirmButtonText="Supprimer"
      onCancel={onClose}
      onConfirm={onConfirm}
      size="sm"
    >
      <p className="text-[var(--color-text-primary)]">
        Êtes-vous sûr de vouloir supprimer la vue &quot;{viewName}&quot; ? Cette
        action est irréversible.
      </p>
    </Modal>
  )
}


